import Persist from '@services/persist'
import Logger from '@services/logger'
import { $config } from '@store/config'
import { CurrentEntityPersist } from '@loctypes'
import { ConfigColorKeys, CssVariables } from './types'
import { getInitialVariables } from './data'

export const $cssVariables = $config.map(
  (state): CssVariables => {
    if (!state) return {} as CssVariables

    const { kind, type } = Persist.memory.get<CurrentEntityPersist>('widgetType')
    const { themeId } = state.modules[kind][type]
    let colorSchema = state.schemas.colors.find(({ id }) => id === themeId)

    if (!colorSchema) {
      Logger.warn('color schema not found')
      colorSchema = state.schemas.colors[0]
    }

    const colors = colorSchema.colors.reduce((acc, color, index) => {
      acc[`--color${index + 1}`] = color

      return acc
    }, {} as Record<ConfigColorKeys, string>)

    const initialVariables = getInitialVariables({ colors: colorSchema.colors })

    return { ...initialVariables, ...colors }
  }
)

export const $cssVariablesLikeCssRoot = $cssVariables.map((state) => {
  const variables = Object.entries(state)
    .map(([varName, value]) => `${varName}:${value};`)
    .join('\n')

  return `:root{${variables}}`.replaceAll('\n', '')
})
